import api from "config/axios.config";
import type {
  CreateAdminDto,
  LoginDto,
  ChangePasswordDto,
  ForgetPasswordDto,
  ResetPasswordDto,
  AuthResponse,
  MessageResponse,
  AdminUser,
} from "./auth.type";

// Service d'authentification correspondant aux routes du backend
export const authService = {
  /**
   * Inscription d'un nouvel admins avec Cognito
   * POST /admins/register
   */
  register: async (data: CreateAdminDto): Promise<AdminUser> => {
    return api.post(`/admins/register`, data);
  },

  /**
   * Vérification de l'email avec code
   * POST /admins/verify-email/:email/:code
   */
  verifyEmail: async (email: string, code: string): Promise<MessageResponse> => {
    return api.post(`/admins/verify-email/${encodeURIComponent(email)}/${code}`);
  },

  /**
   * Renvoyer le code de vérification
   * POST /admins/resend-verification/:email
   */
  resendVerificationCode: async (email: string): Promise<MessageResponse> => {
    return api.post(`/admins/resend-verification/${encodeURIComponent(email)}`);
  },

  /**
   * Connexion
   * POST /admins/login
   */
  login: async (data: LoginDto): Promise<AuthResponse> => {
    return api.post(`/admins/login`, data);
  },

  /**
   * Rafraîchir le token
   * POST /admins/refresh
   */
  refreshToken: async (): Promise<AuthResponse> => {
    return api.post(`/admins/refresh`);
  },

  /**
   * Déconnexion
   * POST /admins/logout
   */
  logout: async (): Promise<MessageResponse> => {
    return api.post(`/admins/logout`);
  },

  /**
   * Changer le mot de passe
   * POST /admins/update-password
   */
  changePassword: async (data: ChangePasswordDto): Promise<MessageResponse> => {
    return api.post(`/admins/update-password`, data);
  },

  /**
   * Demander une réinitialisation de mot de passe
   * POST /admins/forget-password
   */
  forgetPassword: async (data: ForgetPasswordDto): Promise<MessageResponse> => {
    return api.post(`/admins/forget-password`, data);
  },

  /**
   * Réinitialiser le mot de passe avec le code
   * POST /admins/reset-password
   */
  resetPassword: async (data: ResetPasswordDto): Promise<MessageResponse> => {
    return api.post(`/admins/reset-password`, data);
  },
  /**
   * Obtenir l'admin connecté (basé sur le token)
   * GET /admins/me
   */
  getCurrentAdmin: async (): Promise<AdminUser> => {
    return api.get(`/admins/me`);
  },

  /**
   * Mettre à jour l'admins
   * PATCH /admins
   */
  updateAdmin: async (data: Partial<CreateAdminDto>): Promise<AdminUser> => {
    return api.patch(`/admins`, data);
  },
};

export default authService;
